import './dynamic_field_item_component.scss'
